import styled from 'styled-components';
import type { ReactNode } from 'react';

import { media } from 'helpers/breakpoints';

type TMobileProps = {
  children: ReactNode;
  className?: string;
};
type TMobile = (props: TMobileProps) => JSX.Element;

const Container = styled.div`
  ${media.medium} {
    display: none;
  }
`;

const Mobile: TMobile = ({ children, className }) => {
  return <Container className={className}>{children}</Container>;
};

export { Mobile };
